import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-169c08e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 1,
  class: "author"
}
const _hoisted_3 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'HeroHeader',
  props: {
    src: {
        type: String
    },
    author: {
        type: String
    },
    authorLink: {
        type: String
    },
    portrait: {
        type: Boolean,
        default: false
    },
    zoom: {
        type: Number
    },
    fullheight: {
        type: Boolean
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui hero header", {'fullheight': __props.fullheight}])
  }, [
    (props.author)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (props.authorLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: props.authorLink,
                target: "_blank",
                class: "author"
              }, " © " + _toDisplayString(props.author), 9, _hoisted_1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, " © " + _toDisplayString(props.author), 1))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: props.src,
      class: _normalizeClass(props.portrait ? 'portrait' : 'landscape'),
      style: _normalizeStyle(props.zoom ? `transform: scale(${props.zoom});` : null),
      alt: "Une image contextualisée à la page"
    }, null, 14, _hoisted_3),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})